import React, { Component } from "react";

import { Button } from "../Controls";
import { Link } from "react-router";
import "./styles.less";
import { hashHistory } from "react-router";
import InputElement from "react-input-mask";
import CreditCardInput from "react-credit-card-input";
import texts from "../../assets/strings/details.js";
import { PANDA_KEY, PANDA_JS } from "../../constants/constants";

function scriptLoader(scripts, callback) {
  var count = scripts.length;

  function urlCallback(url) {
    return function() {
      console.log(
        url + " was loaded (" + --count + " more scripts remaining)."
      );
      if (count < 1) {
        callback();
      }
    };
  }

  function loadScript(url, id) {
    if (document.getElementById(id)) return false;
    var s = document.createElement("script");
    s.setAttribute("src", url);
    s.setAttribute("id", id);
    s.onload = urlCallback(url);
    document.head.appendChild(s);
  }

  for (var s of scripts) {
    loadScript(s.url, s.id);
  }
}

class PaymentMobile extends Component {
  constructor(props) {
    super(props);
    this.pandaFormRef = React.createRef();
  }
  componentWillMount() {
    if (
      !this.props.reducer ||
      this.props.reducer.target.firstName[0].value === ""
    )
      hashHistory.push("/");
  }

  componentDidMount() {
    scriptLoader(
      [
        {
          url: PANDA_JS,
          id: "panda-js"
        }
      ],
      () => {
        setTimeout(() => {
          Panda.init(PANDA_KEY, "panda_cc_form");
          Panda.on("success", cardToken => {
            this.props.paymentFieldOnChange("token", "token", cardToken);
            hashHistory.push("/review");
          });
          Panda.on("error", errors => {
            console.log("Panda errors: ", errors);
          });
        }, 1000);
      }
    );
  }

  componentWillUnmount = () => {
    document.getElementById("panda-js").remove();
    delete window.Panda;
  };

  onInputChange(evt, section, field) {
    this.props.paymentFieldOnChange(section, field, evt.target.value);
  }

  onInputBlur(evt, section, field) {
    this.props.paymentFieldOnBlur(section, field, evt.target.value);
  }

  renderInput(section, key, field, pandaAttribute) {
    return (
      <div
        className="inputWrapper"
        style={{ width: `${field.width}%` }}
        key={`${key}`}
      >
        <label
          className={`inputLabel ${
            field.valid === true
              ? "valid"
              : field.valid === false
              ? "invalid"
              : ""
          }`}
        >
          {field.label}
        </label>
        {field.mask ? (
          <InputElement
            mask={field.mask}
            value={field.value}
            onChange={evt => this.onInputChange(evt, section, key)}
            onBlur={evt => this.onInputBlur(evt, section, key)}
            type={field.type}
          />
        ) : field.type === "select" ? (
          <select
            onChange={evt => this.onInputChange(evt, section, key)}
            onBlur={evt => this.onInputBlur(evt, section, key)}
          >
            {field.options.map(item => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            mask={field.mask}
            value={field.value}
            data-panda={pandaAttribute}
            onChange={evt => this.onInputChange(evt, section, key)}
            onBlur={evt => this.onInputBlur(evt, section, key)}
            type={field.type}
          />
        )}
      </div>
    );
  }

  renderPaymentForm() {
    const {
      reducer: {
        payment: { method, address }
      }
    } = this.props;
    return (
      <div style={{ padding: 4 }}>
        <section className="paymentSection">
          <h1>{method.label}</h1>
          <div className="inputsRow">
            <div className="cc-inputWrapper" style={{ width: `100%` }}>
              <label className="inputLabel">Card details</label>
              <div className="cc-input">
                <CreditCardInput
                  cardNumberInputRenderer={({
                    handleCardNumberChange,
                    props
                  }) => (
                    <input
                      data-panda="credit_card"
                      {...props}
                      value={method.fields.cc_number.value}
                      onChange={handleCardNumberChange(evt =>
                        this.onInputChange(evt, "method", "cc_number")
                      )}
                      onBlur={handleCardNumberChange(evt =>
                        this.onInputBlur(evt, "method", "cc_number")
                      )}
                    />
                  )}
                  cardExpiryInputRenderer={({
                    handleCardExpiryChange,
                    props
                  }) => (
                    <input
                      {...props}
                      value={method.fields.cc_expDate.value}
                      onChange={handleCardExpiryChange(evt =>
                        this.onInputChange(evt, "method", "cc_expDate")
                      )}
                      onBlur={handleCardExpiryChange(evt =>
                        this.onInputBlur(evt, "method", "cc_expDate")
                      )}
                    />
                  )}
                  cardCVCInputRenderer={({ handleCardCVCChange, props }) => (
                    <input
                      {...props}
                      data-panda="cvv"
                      value={method.fields.cvv_code.value}
                      onChange={handleCardCVCChange(evt =>
                        this.onInputChange(evt, "method", "cvv_code")
                      )}
                      onBlur={handleCardCVCChange(evt =>
                        this.onInputBlur(evt, "method", "cvv_code")
                      )}
                    />
                  )}
                />
                <input
                  type="hidden"
                  data-panda="expiration"
                  value={`${method.fields.cc_expDateMonth.value}/${
                    method.fields.cc_expDateYear.value
                  }`}
                />
                {/* <CreditCardInput
                  cardNumberInputProps={{
                    value: method.fields.cc_number.value,
                    onChange: evt =>
                      this.onInputChange(evt, "method", "cc_number"),
                    onBlur: evt => this.onInputBlur(evt, "method", "cc_number")
                  }}
                  cardExpiryInputProps={{
                    value: method.fields.cc_expDate.value,
                    onChange: evt =>
                      this.onInputChange(evt, "method", "cc_expDate"),
                    onBlur: evt => this.onInputBlur(evt, "method", "cc_expDate")
                  }}
                  cardCVCInputProps={{
                    value: method.fields.cvv_code.value,
                    onChange: evt =>
                      this.onInputChange(evt, "method", "cvv_code"),
                    onBlur: evt => this.onInputBlur(evt, "method", "cvv_code")
                  }}
                  fieldClassName="input"
                /> */}
              </div>
            </div>
          </div>
        </section>
        <section className="paymentSection">
          <div className="inputsRow">
            {this.renderInput(
              "address",
              "bill_firstName",
              address.fields.bill_firstName,
              "first_name"
            )}
            {this.renderInput(
              "address",
              "bill_lastName",
              address.fields.bill_lastName,
              "last_name"
            )}
          </div>
          <div className="inputsRow">
            {this.renderInput(
              "address",
              "bill_email",
              address.fields.bill_email
            )}
          </div>
        </section>
      </div>
    );
    /* <div>
        <section className="paymentSection">
          <h1>{method.label}</h1>
          <div className="inputsRow">
            {this.renderInput("method", "cc_type", method.fields.cc_type)}
          </div>
          <div className="inputsRow">
            {this.renderInput("method", "cc_number", method.fields.cc_number)}
            {this.renderInput("method", "cc_expDate", method.fields.cc_expDate)}
          </div>
          <div className="inputsRow">
            {this.renderInput("method", "cc_name", method.fields.cc_name)}
            {this.renderInput("method", "cvv_code", method.fields.cvv_code)}
          </div>
        </section>
        <section className="paymentSection">
          <h1>{address.label}</h1>
          <div className="inputsRow">
            {this.renderInput(
              "address",
              "bill_firstName",
              address.fields.bill_firstName
            )}
            {this.renderInput(
              "address",
              "bill_lastName",
              address.fields.bill_lastName
            )}
          </div>
          <div className="inputsRow">
            {this.renderInput(
              "address",
              "bill_addressline",
              address.fields.bill_addressline
            )}
          </div>
          <div className="inputsRow">
            {this.renderInput("address", "bill_zip", address.fields.bill_zip)}
            {this.renderInput("address", "bill_city", address.fields.bill_city)}
            {this.renderInput(
              "address",
              "bill_state",
              address.fields.bill_state
            )}
          </div>
          <div className="inputsRow">
            {this.renderInput(
              "address",
              "bill_email",
              address.fields.bill_email
            )}
          </div>
        </section>
      </div> */
  }

  render() {
    const {
      reducer: { payment }
    } = this.props;
    return (
      <form id="panda_cc_form" className="payment mobile">
        <h1>{texts.payment.h1}</h1>
        <h3>{texts.payment.h3}</h3>
        <section style={{ maxWidth: 400, margin: "0px auto" }}>
          {this.renderPaymentForm()}
        </section>
        <p className="note">{texts.payment.note}</p>
        <div className="controls">
          <Button
            primary={true}
            large={true}
            type="submit"
            disabled={!payment.valid}
          >
            {payment.valid ? (
              <div> {texts.payment.actions.next} </div>
            ) : (
              <span>{texts.payment.actions.next}</span>
            )}
          </Button>
        </div>
      </form>
    );
  }
}
export default PaymentMobile;



// WEBPACK FOOTER //
// ./components/Payment/PaymentMobile.js